/**
 * Deposit, withdrawal, notifications inbox — merged into panel locales that
 * otherwise inherit these keys only from English (`en.js`).
 */
export const panelDepositWithdrawInboxByLang = {
  es: {
    'user.deposit.title': 'Depósito',
    'user.deposit.tab.crypto': 'Depósito cripto',
    'user.deposit.tab.evoucher': 'E-Voucher',
    'user.deposit.network.label': 'Red',
    'user.deposit.network.soon': 'Próximamente',
    'user.deposit.network.trc20': 'USDT TRC20',
    'user.deposit.network.erc20': 'USDT ERC20',
    'user.deposit.network.btc': 'BTC',
    'user.deposit.network.eth': 'ETH',
    'user.deposit.crypto.loadAddressFailed': 'No se pudo cargar la dirección de depósito',
    'user.deposit.crypto.genericError': 'Algo salió mal',
    'user.deposit.crypto.loadingAddress': 'Cargando dirección de depósito…',
    'user.deposit.crypto.checking': 'Comprobando…',
    'user.deposit.crypto.checkForDeposit': 'Buscar depósito',
    'user.deposit.crypto.checkFound': '¡Nuevo depósito detectado! Esperando confirmaciones.',
    'user.deposit.crypto.checkNone': 'No hay depósitos nuevos. Vuelve a intentarlo en un momento.',
    'user.deposit.crypto.checkFailed': 'Comprobación fallida',
    'user.deposit.crypto.networkError': 'Error de red',
    'user.deposit.card.title': 'Tu dirección de depósito',
    'user.deposit.card.sendOnly': 'Envía solo USDT TRC20 a esta dirección',
    'user.deposit.card.networkLine': 'Red: solo USDT TRC20',
    'user.deposit.card.confirmationsLine': '{{n}} confirmaciones requeridas (~1 min)',
    'user.deposit.card.valid24h': 'Dirección válida 24 horas',
    'user.deposit.card.warningWrongToken':
      'Envía solo USDT TRC20. Otros tokens o redes pueden suponer pérdida permanente de fondos.',
    'user.deposit.card.scanQr': 'Escanear código QR',
    'user.deposit.card.qrCaption': 'USDT TRC20',
    'user.deposit.expired': 'Caducada',
    'user.deposit.expiresIn': 'Caduca en {{h}}h {{m}}m {{s}}s',
    'user.deposit.history.title': 'Historial de depósitos',
    'user.deposit.history.filter.all': 'Todos',
    'user.deposit.history.filter.pending': 'Pendiente',
    'user.deposit.history.filter.confirming': 'Confirmando',
    'user.deposit.history.filter.completed': 'Completado',
    'user.deposit.history.filter.failed': 'Fallido',
    'user.deposit.history.col.date': 'Fecha',
    'user.deposit.history.col.amount': 'Importe',
    'user.deposit.history.col.status': 'Estado',
    'user.deposit.history.col.confirmations': 'Confirmaciones',
    'user.deposit.history.col.txid': 'TXID',
    'user.deposit.history.emptyTitle': 'Aún no hay depósitos',
    'user.deposit.history.emptyDesc': 'Tu historial de depósitos aparecerá aquí',
    'user.deposit.history.ariaLoading': 'Cargando historial de depósitos',
    'user.deposit.history.ariaTronscan': 'Ver en TronScan',
    'user.deposit.history.pageOf': 'Página {{current}} de {{total}}',
    'user.deposit.depStatus.pending': 'Pendiente',
    'user.deposit.depStatus.confirming': 'Confirmando',
    'user.deposit.depStatus.completed': 'Completado',
    'user.deposit.depStatus.failed': 'Fallido',
    'user.deposit.voucher.redeemTitle': 'Canjear E-Voucher',
    'user.deposit.voucher.generateTitle': 'Generar E-Voucher',
    'user.deposit.voucher.code': 'Código del voucher',
    'user.deposit.voucher.pin': 'PIN de 4 dígitos',
    'user.deposit.voucher.copyPinLabel': 'PIN',
    'user.deposit.voucher.placeholderCode': 'XXXX-XXXX-XXXX',
    'user.deposit.voucher.placeholderPin': '••••',
    'user.deposit.voucher.placeholderAmount': '0,00',
    'user.deposit.voucher.redeem': 'Canjear voucher',
    'user.deposit.voucher.redeeming': 'Canjeando…',
    'user.deposit.voucher.convertHint': 'Convierte tu saldo en un voucher transferible',
    'user.deposit.voucher.amountLabel': 'Importe a convertir',
    'user.deposit.voucher.availableBalance': 'Saldo disponible: {{amount}}',
    'user.deposit.voucher.availableLineLoading': 'Saldo disponible: cargando…',
    'user.deposit.voucher.generate': 'Generar voucher',
    'user.deposit.voucher.generating': 'Generando…',
    'user.deposit.voucher.yourVoucher': 'Tu E-Voucher',
    'user.deposit.voucher.copyAll': 'Copiar todos los datos',
    'user.deposit.voucher.warnOnce': 'Este voucher solo se puede canjear una vez. Guárdalo en un lugar seguro.',
    'user.deposit.voucher.clipboard': 'Código: {{code}}\nPIN: {{pin}}',
    'user.deposit.voucher.toastValidAmount': 'Introduce un importe válido.',
    'user.deposit.voucher.toastCodePin': 'Introduce un código de 12 caracteres y un PIN de 4 dígitos.',
    'user.deposit.voucher.toastGenFail': 'No se pudo generar el voucher.',
    'user.deposit.voucher.toastRedeemFail': 'No se pudo canjear el voucher.',
    'user.deposit.voucher.toastGenOk': 'Voucher generado correctamente.',
    'user.deposit.voucher.toastCopied': 'Datos del voucher copiados.',
    'user.deposit.voucher.toastRedeemed': 'Voucher canjeado. {{amount}} añadidos.',
    'user.withdraw.title': 'Retiro',
    'user.withdraw.form.title': 'Solicitar retiro',
    'user.withdraw.form.method': 'Método de retiro',
    'user.withdraw.form.selectMethod': 'Seleccionar método',
    'user.withdraw.form.walletAddress': 'Dirección de billetera',
    'user.withdraw.form.walletPlaceholder': 'Introduce tu dirección USDT',
    'user.withdraw.form.amount': 'Importe (USD)',
    'user.withdraw.form.available': 'Saldo disponible:',
    'user.withdraw.form.minAmount': 'Retiro mínimo: {{amount}}',
    'user.withdraw.form.maxAmount': 'Retiro máximo: {{amount}}',
    'user.withdraw.form.weekendOnlyHint':
      'Los retiros a billetera solo están disponibles sábado y domingo (hora local). La cancelación anticipada de planes no se ve afectada.',
    'user.withdraw.toast.maxUsd': 'El retiro máximo es {{amount}}',
    'user.withdraw.toast.weekendOnly':
      'Los retiros a billetera solo están disponibles sábado y domingo en tu zona horaria.',
    'user.withdraw.form.loadingBalance': 'Cargando…',
    'user.withdraw.form.placeholderAmount': '0,00',
    'user.withdraw.form.feeTitle': 'Comisión de retiro: {{pct}}%',
    'user.withdraw.form.feeBody':
      'Se deduce un {{pct}}% del importe del retiro. La cancelación anticipada de planes tiene una comisión aparte.',
    'user.withdraw.form.noFeeTitle': 'Sin comisión de plataforma',
    'user.withdraw.form.noFeeBody':
      'Los retiros a billetera no tienen comisión de plataforma. La cancelación anticipada de planes tiene una tarifa aparte.',
    'user.withdraw.form.summaryAmount': 'Importe del retiro',
    'user.withdraw.form.summaryFee': 'Comisión de plataforma',
    'user.withdraw.form.noFee': 'Sin comisión',
    'user.withdraw.form.youReceive': 'Recibirás',
    'user.withdraw.form.request': 'Solicitar retiro',
    'user.withdraw.form.method.trc20': 'USDT TRC20',
    'user.withdraw.form.method.bep20': 'USDT BEP20',
    'user.withdraw.form.method.erc20': 'USDT ERC20',
    'user.withdraw.form.method.evoucher': 'E-Voucher',
    'user.withdraw.form.walletPlaceholderBep20': 'Introduce tu dirección USDT BEP20 (0x…)',
    'user.withdraw.toast.minUsd': 'El retiro mínimo es {{amount}}',
    'user.withdraw.toast.insufficient': 'Saldo insuficiente',
    'user.withdraw.toast.walletRequired': 'La dirección de billetera es obligatoria',
    'user.withdraw.toast.submitFail': 'No se pudo enviar la solicitud de retiro',
    'user.withdraw.toast.submitted': 'Solicitud de retiro enviada',
    'user.withdraw.modal.title': 'Confirmar retiro',
    'user.withdraw.modal.submitting': 'Enviando…',
    'user.withdraw.rules.title': 'Normas de retiro',
    'user.withdraw.rules.cryptoMining': 'Minería cripto',
    'user.withdraw.rules.cryptoMiningPeriod': 'Cada 3 meses',
    'user.withdraw.rules.bullion': 'Comercio de metales',
    'user.withdraw.rules.bullionPeriod': 'Cada 8 meses',
    'user.withdraw.rules.pharma': 'Farmacéuticos',
    'user.withdraw.rules.pharmaPeriod': 'Al final del plan',
    'user.withdraw.rules.supported': 'Métodos admitidos',
    'user.withdraw.rules.feeNote':
      'Los retiros a billetera tienen una comisión del {{pct}}%. La cancelación anticipada de planes usa otra tarifa.',
    'user.withdraw.rules.noFeeNote':
      'Sin comisión en retiros a billetera. La cancelación anticipada de planes usa otra tarifa.',
    'user.withdraw.rules.processingNote':
      'Las solicitudes se procesan en 24-48 horas tras la aprobación.',
    'user.withdraw.history.title': 'Historial de retiros',
    'user.withdraw.history.exportCsv': 'Exportar CSV',
    'user.withdraw.history.empty': 'Aún no hay retiros. El historial aparecerá aquí.',
    'user.withdraw.history.col.date': 'Fecha',
    'user.withdraw.history.col.amount': 'Importe',
    'user.withdraw.history.col.method': 'Método',
    'user.withdraw.history.col.fee': 'Comisión',
    'user.withdraw.history.col.net': 'Importe neto',
    'user.withdraw.history.col.status': 'Estado',
    'user.withdraw.history.col.txid': 'TXID',
    'user.withdraw.history.col.actions': 'Acciones',
    'user.withdraw.history.ariaViewDetails': 'Ver detalles del retiro',
    'user.withdraw.history.ariaCopyTxid': 'Copiar TXID',
    'user.withdraw.detail.title': 'Detalles del retiro',
    'user.withdraw.detail.requestId': 'ID de solicitud',
    'user.withdraw.detail.date': 'Fecha',
    'user.withdraw.detail.method': 'Método',
    'user.withdraw.detail.amount': 'Importe',
    'user.withdraw.detail.fee': 'Comisión',
    'user.withdraw.detail.net': 'Importe neto',
    'user.withdraw.detail.status': 'Estado',
    'user.withdraw.detail.wallet': 'Billetera',
    'user.withdraw.detail.rejectReason': 'Motivo del rechazo:',
    'user.withdraw.st.Pending': 'Pendiente',
    'user.withdraw.st.Completed': 'Completado',
    'user.withdraw.st.Rejected': 'Rechazado',
    'user.withdraw.st.Approved': 'Aprobado',
    'user.withdraw.csv.date': 'Fecha',
    'user.withdraw.csv.amount': 'Importe',
    'user.withdraw.csv.method': 'Método',
    'user.withdraw.csv.fee': 'Comisión',
    'user.withdraw.csv.net': 'Importe neto',
    'user.withdraw.csv.status': 'Estado',
    'user.withdraw.csv.txid': 'TXID',
    'user.notifications.title': 'Notificaciones',
    'inbox.summary': '{{total}} en total · {{unread}} sin leer',
    'inbox.loadingSummary': 'Cargando…',
    'inbox.refresh': 'Actualizar',
    'inbox.refreshAria': 'Actualizar notificaciones',
    'inbox.markAllRead': 'Marcar todo como leído',
    'inbox.loadingList': 'Cargando notificaciones…',
    'inbox.empty': 'Aún no hay notificaciones.',
    'inbox.openRelated': 'Abrir página relacionada →',
    'inbox.markReadAria': 'Marcar como leído',
    'inbox.removeAria': 'Eliminar',
    'inbox.pageOf': 'Página {{current}} / {{total}}',
    'inbox.time.justNow': 'ahora mismo',
    'inbox.time.secAgo': 'hace {{sec}} s',
    'inbox.time.minAgo': 'hace {{min}} min',
    'inbox.time.hrAgo': 'hace {{hr}} h',
  },

  de: {
    'user.deposit.title': 'Einzahlung',
    'user.deposit.tab.crypto': 'Krypto-Einzahlung',
    'user.deposit.tab.evoucher': 'E-Gutschein',
    'user.deposit.network.label': 'Netzwerk',
    'user.deposit.network.soon': 'Demnächst',
    'user.deposit.network.trc20': 'USDT TRC20',
    'user.deposit.network.erc20': 'USDT ERC20',
    'user.deposit.network.btc': 'BTC',
    'user.deposit.network.eth': 'ETH',
    'user.deposit.crypto.loadAddressFailed': 'Einzahlungsadresse konnte nicht geladen werden',
    'user.deposit.crypto.genericError': 'Etwas ist schiefgelaufen',
    'user.deposit.crypto.loadingAddress': 'Einzahlungsadresse wird geladen…',
    'user.deposit.crypto.checking': 'Wird geprüft…',
    'user.deposit.crypto.checkForDeposit': 'Auf Einzahlung prüfen',
    'user.deposit.crypto.checkFound': 'Neue Einzahlung erkannt! Warte auf Bestätigungen.',
    'user.deposit.crypto.checkNone': 'Keine neue Einzahlung. Bitte später erneut prüfen.',
    'user.deposit.crypto.checkFailed': 'Prüfung fehlgeschlagen',
    'user.deposit.crypto.networkError': 'Netzwerkfehler',
    'user.deposit.card.title': 'Ihre Einzahlungsadresse',
    'user.deposit.card.sendOnly': 'Senden Sie nur USDT TRC20 an diese Adresse',
    'user.deposit.card.networkLine': 'Netzwerk: nur USDT TRC20',
    'user.deposit.card.confirmationsLine': '{{n}} Bestätigungen erforderlich (~1 Min.)',
    'user.deposit.card.valid24h': 'Adresse 24 Stunden gültig',
    'user.deposit.card.warningWrongToken':
      'Nur USDT TRC20 senden. Andere Token oder Netzwerke können zu dauerhaftem Verlust führen.',
    'user.deposit.card.scanQr': 'QR-Code scannen',
    'user.deposit.card.qrCaption': 'USDT TRC20',
    'user.deposit.expired': 'Abgelaufen',
    'user.deposit.expiresIn': 'Läuft ab in {{h}}h {{m}}m {{s}}s',
    'user.deposit.history.title': 'Einzahlungsverlauf',
    'user.deposit.history.filter.all': 'Alle',
    'user.deposit.history.filter.pending': 'Ausstehend',
    'user.deposit.history.filter.confirming': 'Bestätigung',
    'user.deposit.history.filter.completed': 'Abgeschlossen',
    'user.deposit.history.filter.failed': 'Fehlgeschlagen',
    'user.deposit.history.col.date': 'Datum',
    'user.deposit.history.col.amount': 'Betrag',
    'user.deposit.history.col.status': 'Status',
    'user.deposit.history.col.confirmations': 'Bestätigungen',
    'user.deposit.history.col.txid': 'TXID',
    'user.deposit.history.emptyTitle': 'Noch keine Einzahlungen',
    'user.deposit.history.emptyDesc': 'Ihr Einzahlungsverlauf erscheint hier',
    'user.deposit.history.ariaLoading': 'Einzahlungsverlauf wird geladen',
    'user.deposit.history.ariaTronscan': 'Auf TronScan ansehen',
    'user.deposit.history.pageOf': 'Seite {{current}} von {{total}}',
    'user.deposit.depStatus.pending': 'Ausstehend',
    'user.deposit.depStatus.confirming': 'Bestätigung',
    'user.deposit.depStatus.completed': 'Abgeschlossen',
    'user.deposit.depStatus.failed': 'Fehlgeschlagen',
    'user.deposit.voucher.redeemTitle': 'E-Gutschein einlösen',
    'user.deposit.voucher.generateTitle': 'E-Gutschein erstellen',
    'user.deposit.voucher.code': 'Gutscheincode',
    'user.deposit.voucher.pin': '4-stellige PIN',
    'user.deposit.voucher.copyPinLabel': 'PIN',
    'user.deposit.voucher.placeholderCode': 'XXXX-XXXX-XXXX',
    'user.deposit.voucher.placeholderPin': '••••',
    'user.deposit.voucher.placeholderAmount': '0,00',
    'user.deposit.voucher.redeem': 'Gutschein einlösen',
    'user.deposit.voucher.redeeming': 'Wird eingelöst…',
    'user.deposit.voucher.convertHint': 'Saldo in übertragbaren Gutschein umwandeln',
    'user.deposit.voucher.amountLabel': 'Umzuwandelnder Betrag',
    'user.deposit.voucher.availableBalance': 'Verfügbares Guthaben: {{amount}}',
    'user.deposit.voucher.availableLineLoading': 'Verfügbares Guthaben: wird geladen…',
    'user.deposit.voucher.generate': 'Gutschein erstellen',
    'user.deposit.voucher.generating': 'Wird erstellt…',
    'user.deposit.voucher.yourVoucher': 'Ihr E-Gutschein',
    'user.deposit.voucher.copyAll': 'Alle Angaben kopieren',
    'user.deposit.voucher.warnOnce': 'Dieser Gutschein kann nur einmal eingelöst werden. Bewahren Sie ihn sicher auf.',
    'user.deposit.voucher.clipboard': 'Code: {{code}}\nPIN: {{pin}}',
    'user.deposit.voucher.toastValidAmount': 'Bitte einen gültigen Betrag eingeben.',
    'user.deposit.voucher.toastCodePin': 'Bitte einen gültigen 12-stelligen Code und eine 4-stellige PIN eingeben.',
    'user.deposit.voucher.toastGenFail': 'Gutschein konnte nicht erstellt werden.',
    'user.deposit.voucher.toastRedeemFail': 'Gutschein konnte nicht eingelöst werden.',
    'user.deposit.voucher.toastGenOk': 'Gutschein erfolgreich erstellt.',
    'user.deposit.voucher.toastCopied': 'Gutscheindaten kopiert.',
    'user.deposit.voucher.toastRedeemed': 'Gutschein eingelöst. +{{amount}} gutgeschrieben.',
    'user.withdraw.title': 'Auszahlung',
    'user.withdraw.form.title': 'Auszahlung beantragen',
    'user.withdraw.form.method': 'Auszahlungsmethode',
    'user.withdraw.form.selectMethod': 'Methode wählen',
    'user.withdraw.form.walletAddress': 'Wallet-Adresse',
    'user.withdraw.form.walletPlaceholder': 'Ihre USDT-Wallet-Adresse eingeben',
    'user.withdraw.form.amount': 'Betrag (USD)',
    'user.withdraw.form.available': 'Verfügbares Guthaben:',
    'user.withdraw.form.minAmount': 'Mindestauszahlung: {{amount}}',
    'user.withdraw.form.maxAmount': 'Höchstauszahlung: {{amount}}',
    'user.withdraw.form.weekendOnlyHint':
      'Wallet-Auszahlungen sind nur Samstag und Sonntag möglich (Ortszeit). Vorzeitige Plan-Kündigung ist nicht betroffen.',
    'user.withdraw.toast.maxUsd': 'Höchstauszahlung ist {{amount}}',
    'user.withdraw.toast.weekendOnly':
      'Wallet-Auszahlungen sind in Ihrer Zeitzone nur Samstag und Sonntag möglich.',
    'user.withdraw.form.loadingBalance': 'Wird geladen…',
    'user.withdraw.form.placeholderAmount': '0,00',
    'user.withdraw.form.feeTitle': 'Auszahlungsgebühr: {{pct}}%',
    'user.withdraw.form.feeBody':
      'Es werden {{pct}}% vom Auszahlungsbetrag abgezogen. Die vorzeitige Plan-Kündigung hat eine separate Gebühr.',
    'user.withdraw.form.noFeeTitle': 'Keine Plattformgebühr',
    'user.withdraw.form.noFeeBody':
      'Wallet-Auszahlungen haben keine Plattformgebühr. Die vorzeitige Plan-Kündigung hat eine separate Gebühr.',
    'user.withdraw.form.summaryAmount': 'Auszahlungsbetrag',
    'user.withdraw.form.summaryFee': 'Plattformgebühr',
    'user.withdraw.form.noFee': 'Keine Gebühr',
    'user.withdraw.form.youReceive': 'Sie erhalten',
    'user.withdraw.form.request': 'Auszahlung beantragen',
    'user.withdraw.form.method.trc20': 'USDT TRC20',
    'user.withdraw.form.method.bep20': 'USDT BEP20',
    'user.withdraw.form.method.erc20': 'USDT ERC20',
    'user.withdraw.form.method.evoucher': 'E-Gutschein',
    'user.withdraw.form.walletPlaceholderBep20': 'Ihre USDT BEP20-Adresse eingeben (0x…)',
    'user.withdraw.toast.minUsd': 'Mindestauszahlung ist {{amount}}',
    'user.withdraw.toast.insufficient': 'Unzureichendes Guthaben',
    'user.withdraw.toast.walletRequired': 'Wallet-Adresse ist erforderlich',
    'user.withdraw.toast.submitFail': 'Auszahlungsantrag konnte nicht gesendet werden',
    'user.withdraw.toast.submitted': 'Auszahlungsantrag gesendet',
    'user.withdraw.modal.title': 'Auszahlung bestätigen',
    'user.withdraw.modal.submitting': 'Wird gesendet…',
    'user.withdraw.rules.title': 'Auszahlungsregeln',
    'user.withdraw.rules.cryptoMining': 'Krypto-Mining',
    'user.withdraw.rules.cryptoMiningPeriod': 'Alle 3 Monate',
    'user.withdraw.rules.bullion': 'Edelmetallhandel',
    'user.withdraw.rules.bullionPeriod': 'Alle 8 Monate',
    'user.withdraw.rules.pharma': 'Pharma',
    'user.withdraw.rules.pharmaPeriod': 'Ende der Planlaufzeit',
    'user.withdraw.rules.supported': 'Unterstützte Methoden',
    'user.withdraw.rules.feeNote':
      'Auf Wallet-Auszahlungen fallen {{pct}}% Plattformgebühr an. Die vorzeitige Plan-Kündigung hat eine separate Gebühr.',
    'user.withdraw.rules.noFeeNote':
      'Keine Plattformgebühr auf Wallet-Auszahlungen. Die vorzeitige Plan-Kündigung hat eine separate Gebühr.',
    'user.withdraw.rules.processingNote':
      'Auszahlungsanträge werden innerhalb von 24–48 Stunden nach Genehmigung bearbeitet.',
    'user.withdraw.history.title': 'Auszahlungsverlauf',
    'user.withdraw.history.exportCsv': 'CSV exportieren',
    'user.withdraw.history.empty': 'Noch keine Auszahlungen. Der Verlauf erscheint hier.',
    'user.withdraw.history.col.date': 'Datum',
    'user.withdraw.history.col.amount': 'Betrag',
    'user.withdraw.history.col.method': 'Methode',
    'user.withdraw.history.col.fee': 'Gebühr',
    'user.withdraw.history.col.net': 'Nettobetrag',
    'user.withdraw.history.col.status': 'Status',
    'user.withdraw.history.col.txid': 'TXID',
    'user.withdraw.history.col.actions': 'Aktionen',
    'user.withdraw.history.ariaViewDetails': 'Auszahlungsdetails anzeigen',
    'user.withdraw.history.ariaCopyTxid': 'TXID kopieren',
    'user.withdraw.detail.title': 'Auszahlungsdetails',
    'user.withdraw.detail.requestId': 'Antrags-ID',
    'user.withdraw.detail.date': 'Datum',
    'user.withdraw.detail.method': 'Methode',
    'user.withdraw.detail.amount': 'Betrag',
    'user.withdraw.detail.fee': 'Gebühr',
    'user.withdraw.detail.net': 'Nettobetrag',
    'user.withdraw.detail.status': 'Status',
    'user.withdraw.detail.wallet': 'Wallet',
    'user.withdraw.detail.rejectReason': 'Ablehnungsgrund:',
    'user.withdraw.st.Pending': 'Ausstehend',
    'user.withdraw.st.Completed': 'Abgeschlossen',
    'user.withdraw.st.Rejected': 'Abgelehnt',
    'user.withdraw.st.Approved': 'Genehmigt',
    'user.withdraw.csv.date': 'Datum',
    'user.withdraw.csv.amount': 'Betrag',
    'user.withdraw.csv.method': 'Methode',
    'user.withdraw.csv.fee': 'Gebühr',
    'user.withdraw.csv.net': 'Nettobetrag',
    'user.withdraw.csv.status': 'Status',
    'user.withdraw.csv.txid': 'TXID',
    'user.notifications.title': 'Benachrichtigungen',
    'inbox.summary': '{{total}} gesamt · {{unread}} ungelesen',
    'inbox.loadingSummary': 'Wird geladen…',
    'inbox.refresh': 'Aktualisieren',
    'inbox.refreshAria': 'Benachrichtigungen aktualisieren',
    'inbox.markAllRead': 'Alle als gelesen markieren',
    'inbox.loadingList': 'Benachrichtigungen werden geladen…',
    'inbox.empty': 'Noch keine Benachrichtigungen.',
    'inbox.openRelated': 'Zugehörige Seite öffnen →',
    'inbox.markReadAria': 'Als gelesen markieren',
    'inbox.removeAria': 'Entfernen',
    'inbox.pageOf': 'Seite {{current}} / {{total}}',
    'inbox.time.justNow': 'gerade eben',
    'inbox.time.secAgo': 'vor {{sec}} s',
    'inbox.time.minAgo': 'vor {{min}} Min',
    'inbox.time.hrAgo': 'vor {{hr}} Std',
  },
};
